import { Component, input, InputSignal, OnChanges, OnInit, signal, WritableSignal } from '@angular/core';

export type ButtonColor = 'orange' | 'black' | 'red' | 'green' | 'blue' | 'white' | 'yellow';
type ButtonSize = 'xs' | 'sm' | 'base' | 'lg';
type ButtonFill = 'full' | 'outline' | 'clear' | 'color';
type ButtonType = 'submit' | 'button';

/**
 * Keep for TailwindCSS
 *
 * bg-orange border-orange text-orange hover:bg-orange-accent
 * bg-black border-black text-black hover:bg-black-accent
 * bg-red border-red text-red hover:bg-red-accent
 * bg-green border-green text-green hover:bg-green-accent
 * bg-blue border-blue text-blue hover:bg-blue-accent
 * bg-white border-white text-white hover:bg-white-accent
 * bg-yellow border-yellow text-yellow hover:bg-yellow-accent
 */

@Component({
    selector: 'app-button',
    imports: [],
    templateUrl: './button.component.html',
})
export class ButtonComponent implements OnInit, OnChanges {
    public color: InputSignal<ButtonColor> = input<ButtonColor>('orange');
    public size: InputSignal<ButtonSize> = input<ButtonSize>('base');
    public fill: InputSignal<ButtonFill> = input<ButtonFill>('full');
    public type: InputSignal<ButtonType> = input<ButtonType>('button');
    public disabled: InputSignal<boolean> = input<boolean>(false);
    public bold: InputSignal<boolean> = input<boolean>(true);
    public underline: InputSignal<boolean> = input<boolean>(false);

    public classes: WritableSignal<string> = signal('');
    public slotClasses: WritableSignal<string> = signal('');

    public ngOnInit(): void {
        this.setClasses();
    }

    public ngOnChanges(): void {
        this.setClasses();
    }

    private setClasses(): void {
        let classes = '';
        let slotClasses = '';

        switch (this.fill()) {
            case 'full':
                classes += ' border border-solid';
                classes += ' border-' + this.color();
                classes += ' bg-' + this.color() + ' hover:bg-' + this.color() + '-accent duration-200';
                break;
            case 'outline':
                classes += ' border-2 border-solid';
                classes += ' border-' + this.color();
                slotClasses += ' text-' + this.color();
                break;
        }

        switch (this.size()) {
            case 'lg':
                classes += ' w-full';
                slotClasses += ' px-6 py-3 text-xl';
                break;
            case 'base':
                slotClasses += ' px-4 py-2.5 text-base';
                break;
            case 'sm':
                slotClasses += ' px-3.5 py-2 text-sm';
                break;
            case 'xs':
                slotClasses += ' px-3 py-2 text-xs';
                break;
        }

        if (this.fill() === 'outline' && this.size() === 'xs') {
            classes += ' !border-1';
        }

        if (this.fill() !== 'outline') {
            if (this.fill() === 'color') {
                classes += ' text-' + this.color();
            } else if (this.color() === 'white' || this.fill() === 'clear') {
                classes += ' text-black';
            } else {
                classes += ' text-white';
            }
        }

        if (this.fill() !== 'color') {
            if (
                this.color() === 'orange' ||
                this.color() === 'blue' ||
                this.color() === 'red' ||
                this.color() === 'green'
            ) {
                classes += ' !text-white';
            }
        }

        this.classes.set(classes);
        this.slotClasses.set(slotClasses);
    }
}
